"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveReportPage = getActiveReportPage;
exports.setReportPage = setReportPage;
exports.getReportVisual = getReportVisual;
exports.exportVisualData = exportVisualData;
exports.setMarktdatenDateFilter = setMarktdatenDateFilter;
exports.setMarktdatenTableSort = setMarktdatenTableSort;
exports.isMarktdatenButtonClicked = isMarktdatenButtonClicked;
exports.handleMarktdatenButtonClicked = handleMarktdatenButtonClicked;
exports.setBoersepreiseDateFilter = setBoersepreiseDateFilter;
exports.setBoersepreiseTableSort = setBoersepreiseTableSort;
exports.handleBoersepreiseButtonClicked = handleBoersepreiseButtonClicked;
exports.handleMilchanlieferungButtonClicked = handleMilchanlieferungButtonClicked;
exports.setPreisberichtYearFilter = setPreisberichtYearFilter;
exports.handleFlaechenButtonClicked = handleFlaechenButtonClicked;
const reportConstants_1 = require("@/config/reportConstants");
const powerbi_client_1 = require("powerbi-client");
const windows1252 = __importStar(require("windows-1252"));
//
// common utility functions
//
/*
async function debugShowVisualInfos(report: Report): Promise<void> {
    const page = await getActiveReportPage(report); //  report.getActivePage();
    const visuals = await page.getVisuals();
    visuals.map(v => console.log(`name=${v.name}, type=${v.type}, title=${v.title}`));
}
*/
function getActiveReportPage(report) {
    return __awaiter(this, void 0, void 0, function* () {
        const reportPages = yield report.getPages();
        return reportPages.filter((page) => page.isActive)[0];
    });
}
function setReportPage(report, pageName) {
    return __awaiter(this, void 0, void 0, function* () {
        if (report === undefined) {
            throw new Error("Report is not available (undefined)");
        }
        report.setPage(pageName);
    });
}
function getReportVisual(page, name, type) {
    return __awaiter(this, void 0, void 0, function* () {
        const visuals = yield page.getVisuals();
        return visuals.filter((visual) => {
            return visual.name === name && (type === undefined || visual.type === type);
        })[0];
    });
}
function downloadData(data, mimeType, filename) {
    return __awaiter(this, void 0, void 0, function* () {
        const blob = new Blob([data], { type: mimeType });
        const a = document.createElement('a');
        a.download = filename;
        a.href = URL.createObjectURL(blob);
        a.dataset.downloadurl = [mimeType, a.download, a.href].join(':');
        const e = document.createEvent('MouseEvents');
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
    });
}
function parseCSV(str, rowCallback) {
    let rowData = [];
    let quote = false;
    for (let row = 0, col = 0, c = 0; c < str.length; c++) {
        const currentChar = str[c];
        const nextChar = str[c + 1];
        rowData[col] = rowData[col] || '';
        if (currentChar == '"' && quote && nextChar == '"') {
            rowData[col] += currentChar;
            ++c;
            continue;
        }
        if (currentChar == '"') {
            quote = !quote;
            continue;
        }
        if (currentChar == ',' && !quote) {
            ++col;
            continue;
        }
        if (currentChar == '\r' && nextChar == '\n' && !quote) {
            rowCallback(row, rowData);
            rowData = [];
            ++row;
            col = 0;
            ++c;
            continue;
        }
        if ((currentChar == '\n' || currentChar == '\r') && !quote) {
            rowCallback(row, rowData);
            rowData = [];
            ++row;
            col = 0;
            continue;
        }
        rowData[col] += currentChar;
    }
}
const NUMBER_FORMAT_DE = Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
function convertToLocalizedNumber(data) {
    const num = parseFloat(data);
    if (isNaN(num)) {
        return data; // leave untouched
    }
    return NUMBER_FORMAT_DE.format(num);
}
const CSV_COLUMN_NAME_WERT = "Wert";
const CSV_COLUMN_NAME_TONNEN = "Tonnen";
const CSV_OUT_DELEMITER = ";";
const CSV_OUT_QUOTE = "\"";
function convertCSVToAnsi(data) {
    let csv = '';
    let wertColumnIndex = -1;
    let tonnenColumnIndex = -1;
    parseCSV(data, (rowIndex, rowData) => {
        // convert number columns
        // TODO: make this more generic
        // is header row?
        if (rowIndex == 0) {
            wertColumnIndex = rowData.indexOf(CSV_COLUMN_NAME_WERT);
            tonnenColumnIndex = rowData.indexOf(CSV_COLUMN_NAME_TONNEN);
        }
        else {
            if (wertColumnIndex != -1) {
                rowData[wertColumnIndex] = convertToLocalizedNumber(rowData[wertColumnIndex]);
            }
            if (tonnenColumnIndex != -1) {
                rowData[tonnenColumnIndex] = convertToLocalizedNumber(rowData[tonnenColumnIndex]);
            }
        }
        // reconstruct csv output line
        csv += rowData.map(data => CSV_OUT_QUOTE + data.replace(CSV_OUT_QUOTE, "\\" + CSV_OUT_QUOTE) + CSV_OUT_QUOTE).join(CSV_OUT_DELEMITER);
        csv += '\n';
    });
    // encode utf8 to ansi (windows-cp1252)
    return windows1252.encode(csv, { mode: 'replacement' });
}
function exportVisualData(marktdatenReport, visualName) {
    return __awaiter(this, void 0, void 0, function* () {
        const page = yield getActiveReportPage(marktdatenReport);
        // debug begin
        //const visuals = await page.getVisuals();
        //visuals.map(v => console.log(`name=${v.name}, type=${v.type}`));
        // debug end
        const visual = yield getReportVisual(page, visualName);
        if (visual) {
            // export visual data: https://learn.microsoft.com/de-de/javascript/api/overview/powerbi/export-data
            const result = yield visual.exportData(powerbi_client_1.models.ExportDataType.Summarized);
            yield downloadData(convertCSVToAnsi(result.data), "text/csv", "data.csv");
        }
        else {
            console.log("Error: Unable to find visual.");
        }
    });
}
//
// Marktdaten-Report specific utility functions
//
/*
export async function setYearSlicerFilter(report: Report, yearGreaterThanOrEqual: number): Promise<void> {
    //const slicerType = "advancedSlicerVisual";
    const slicerName = "4ecdad6eaa7893ed2448"; // year slicer name (Report: Marktdaten)
    // Create the filter object. For more information see https://go.microsoft.com/fwlink/?linkid=2153364
    const filter: models.IAdvancedFilter = {
        $schema: "http://powerbi.com/product/schema#advanced",
        filterType: models.FilterType.Advanced,
        target: {
            table: "MELDUNGSDATEN",
            column: "Jahr"
        },
        logicalOperator: "And",
        conditions: [
            {
                operator: "GreaterThanOrEqual",
                value: yearGreaterThanOrEqual
            },
        ]
    };
    // Get active page of report
    const activePage = await getActiveReportPage(report);
    // Get the slicer
    const slicer = await getReportVisual(activePage, slicerName);
    if (!slicer) {
        console.log(`WARN: Unable to set slicer filter. Slicer not found. (name=${slicerName})`);
        return;
    }
    // Set the slicer state which contains the slicer filters
    await slicer.setSlicerState({ filters: [filter] });
}
*/
const NEWLINE_CHARACTER = /\r?\n/;
function setYearSlicerFilter(report, slicerId, slicerTableName, slicerColumnName, lastYearCount) {
    return __awaiter(this, void 0, void 0, function* () {
        // get the visual (slicer) from active page
        const activePage = yield getActiveReportPage(report);
        const visual = yield getReportVisual(activePage, slicerId);
        if (!visual) {
            console.log(`WARN: Unable to set visual filter. Visual not found. (name=${slicerId})`);
            return;
        }
        // get current slicer data
        const slicerExportResult = yield visual.exportData(powerbi_client_1.models.ExportDataType.Summarized);
        if (!slicerExportResult || !slicerExportResult.data) {
            return;
        }
        // create list of years
        const yearList = [];
        const dataArray = slicerExportResult.data.split(NEWLINE_CHARACTER);
        dataArray.forEach(value => {
            const year = parseInt(value);
            if (!isNaN(year)) {
                yearList.push(year);
            }
        });
        yearList.sort().reverse();
        yearList.splice(lastYearCount || reportConstants_1.MARKTDATEN_DEFAULT_YEAR_COUNT);
        // use basic filter with "In" operator to visually select items in dropdown
        const filter = {
            $schema: "http://powerbi.com/product/schema#basic",
            filterType: powerbi_client_1.models.FilterType.Basic,
            target: {
                table: slicerTableName,
                column: slicerColumnName
            },
            operator: "In",
            values: yearList
        };
        // Set the slicer state which contains the slicer filters
        yield visual.setSlicerState({
            filters: [filter]
        });
        // Sort by year dscending
        yield visual.sortBy({
            orderBy: {
                table: slicerTableName,
                column: slicerColumnName
            },
            direction: powerbi_client_1.models.SortDirection.Descending
        });
    });
}
function setMarktdatenDateFilter(report, years) {
    return __awaiter(this, void 0, void 0, function* () {
        yield setYearSlicerFilter(report, reportConstants_1.MARKTDATEN_YEAR_SLICER_ID, reportConstants_1.MARKTDATEN_YEAR_SLICER_TABLE_NAME, reportConstants_1.MARKTDATEN_YEAR_SLICER_COLUMN_NAME, years);
    });
}
function setMarktdatenTableSort(marktdatenReport) {
    return __awaiter(this, void 0, void 0, function* () {
        // name of table (Report: Marktdaten) 
        const visualName = reportConstants_1.MARKTDATEN_TABLE_ID;
        // Get active page of report
        const activePage = yield getActiveReportPage(marktdatenReport);
        // Get the visual (slicer)
        const visual = yield getReportVisual(activePage, visualName);
        if (!visual) {
            console.log(`WARN: Visual not found. (name=${visualName})`);
            return;
        }
        // Sort by year dscending
        yield visual.sortBy({
            orderBy: {
                table: reportConstants_1.MARKTDATEN_TABLE_NAME,
                //measure: MARKTDATEN_TABLE_DATE_COLUMN_NAME
                column: reportConstants_1.MARKTDATEN_TABLE_DATE_COLUMN_NAME
            },
            direction: powerbi_client_1.models.SortDirection.Descending
        });
    });
}
function isMarktdatenButtonClicked(event) {
    return event.button.id == reportConstants_1.MARKTDATEN_TABLE_BUTTON_ID ||
        event.button.id == reportConstants_1.MARKTDATEN_LINECHART_BUTTON_ID ||
        event.button.id == reportConstants_1.MARKTDATEN_BARCHART_BUTTON_ID ||
        event.button.id == reportConstants_1.MARKTDATEN_EXPORT_BUTTON_ID ||
        event.button.id == reportConstants_1.MARKTDATEN_RESET_BUTTON_ID;
}
function handleMarktdatenButtonClicked(event) {
    return __awaiter(this, void 0, void 0, function* () {
        // Export Button clicked?
        if (event.button.id === reportConstants_1.MARKTDATEN_EXPORT_BUTTON_ID) {
            yield exportVisualData(event.report, reportConstants_1.MARKTDATEN_TABLE_ID);
        }
    });
}
function setBoersepreiseDateFilter(report, years) {
    return __awaiter(this, void 0, void 0, function* () {
        yield setYearSlicerFilter(report, reportConstants_1.BOERSEPREISE_YEAR_SLICER_ID, reportConstants_1.BOERSEPREISE_YEAR_SLICER_TABLE_NAME, reportConstants_1.BOERSEPREISE_YEAR_SLICER_COLUMN_NAME, years);
    });
}
function setBoersepreiseTableSort(marktdatenReport) {
    return __awaiter(this, void 0, void 0, function* () {
        // name of table (Report: Marktdaten) 
        const visualName = reportConstants_1.BOERSEPREISE_TABLE_ID;
        // Get active page of report
        const activePage = yield getActiveReportPage(marktdatenReport);
        // Get the visual (slicer)
        const visual = yield getReportVisual(activePage, visualName);
        if (!visual) {
            console.log(`WARN: Visual not found. (name=${visualName})`);
            return;
        }
        // Sort by year dscending
        yield visual.sortBy({
            orderBy: {
                table: reportConstants_1.BOERSEPREISE_TABLE_NAME,
                column: reportConstants_1.BOERSEPREISE_TABLE_DATE_COLUMN_NAME
            },
            direction: powerbi_client_1.models.SortDirection.Descending
        });
    });
}
function handleBoersepreiseButtonClicked(event) {
    return __awaiter(this, void 0, void 0, function* () {
        // Export Button clicked?
        if (event.button.id === reportConstants_1.BOERSEPREISE_EXPORT_BUTTON_ID) {
            yield exportVisualData(event.report, reportConstants_1.BOERSEPREISE_TABLE_ID);
        }
    });
}
function handleMilchanlieferungButtonClicked(event) {
    return __awaiter(this, void 0, void 0, function* () {
        // Export Button clicked?
        if (event.button.id === reportConstants_1.MILCHANLIEFERUNG_EXPORT_BUTTON_ID) {
            yield exportVisualData(event.report, reportConstants_1.MILCHANLIEFERUNG_TABLE_ID);
        }
    });
}
// Preisbericht
function setPreisberichtYearFilter(report) {
    return __awaiter(this, void 0, void 0, function* () {
        setMarktdatenDateFilter(report, reportConstants_1.MARKTDATEN_PREISBERICHT_YEAR_COUNT);
    });
}
// Flächen
function handleFlaechenButtonClicked(event) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log("button.id=%s", event.button.id);
        // Export Button clicked?
        if (event.button.id === reportConstants_1.FLAECHEN_EXPORT_BUTTON_ID) {
            yield exportVisualData(event.report, reportConstants_1.FLAECHEN_TABLE_ID);
        }
    });
}
